import {useEffect} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css' 

import {HeaderWrapper} from './components/header'
import {ScrollTop} from './components/scroll-top'
import {Content} from './components/content'
import {FooterWrapper} from './components/footer'
import {Sidebar} from './components/sidebar'
// import {ActivityDrawer, DrawerMessenger, InviteUsers} from '../partials'
import {PageDataProvider} from './core'
import {reInitMenu} from '../helpers'
import {ToolbarWrapper} from './components/toolbar'
import {ThemeModeProvider} from '../partials/layout/theme-mode/ThemeModeProvider'
import {MasterInit} from './MasterInit'

import '../assets/sass/theme-overrides.scss'

const MasterLayout = () => {
  const location = useLocation()
  useEffect(() => {
    reInitMenu()
  }, [location.key])

  return (
    <PageDataProvider>
      <ThemeModeProvider>
        <div className='d-flex flex-column flex-root app-root' id='sc_app_root'>
          <div className='app-page flex-column flex-column-fluid' id='sc_app_page'>
            <HeaderWrapper />
            <div className='app-wrapper flex-column flex-row-fluid' id='sc_app_wrapper'>
              <Sidebar />
              <div className='app-main flex-column flex-row-fluid' id='sc_app_main'>
                <div className='d-flex flex-column flex-column-fluid'>
                  <ToolbarWrapper />
                  <Content>
                    <Outlet />
                  </Content>
                </div>
                <FooterWrapper />
              </div>
            </div>
          </div>
        </div>

        {/* Konfigurasi Standar untuk Yarn/React 18 */}
        {/* <ToastContainer 
          position="top-right"
          autoClose={3000}
          theme="colored"
          limit={1} // Batasi 1 agar memori tidak overload saat pindah halaman
        /> */}

        {/* <ActivityDrawer /> */}
        {/* <DrawerMessenger /> */}
        {/* <InviteUsers /> */}
        {/* <Phone /> */}
        <MasterInit />
      </ThemeModeProvider>
    </PageDataProvider>
  )
}

export {MasterLayout}
